import { useState } from "react"

export function useTheme() {
  const [theme, setThemeState] = useState<"light" | "dark">(() => {
    if (typeof document === "undefined") return "light"
    return document.documentElement.classList.contains("dark") ? "dark" : "light"
  })

  const setTheme = (t: "light" | "dark") => {
    document.documentElement.classList.toggle("dark", t === "dark")
    try { localStorage.setItem("innly-theme", t) } catch(e) {}
    setThemeState(t)
  }

  return { theme, setTheme }
}
